import { AppConfig } from './types';

// Development configuration (will be replaced during build)
const config: AppConfig = {
  apiBaseUrl: process.env.REACT_APP_API_URL || 'https://api.example.com/dev',
  region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
  userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
  userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
  identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || '',
};

export default config;